<template>
  <el-dialog
    title="选择审批流程"
    :visible.sync="visible"
    width="440px"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="选择流程：" prop="flow_id">
        <el-select
          size="small"
          v-model="model.flow_id"
          filterable
          placeholder="选择流程"
          style="width:100%"
        >
          <el-option
            v-for="flow in flows"
            :key="flow.id"
            :label="flow.name"
            :value="flow.id"
          >
            <div class="flow-item">
              <div>{{ flow.name }}</div>
              <el-breadcrumb
                separator-class="el-icon-arrow-right"
                style="border:none; padding:0"
              >
                <el-breadcrumb-item
                  v-for="(item, index) in flow.approver_users"
                  :key="index"
                  >{{ item.name }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { updateCustomer, userList, flowList } from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    }
  },
  data() {
    return {
      visible: this.show,
      model: {
        flow_id: null
      },
      formRules: {
        flow_id: [
          { required: true, message: '请选择审批流程', trigger: 'change' }
        ]
      },
      submiting: false,
      flows: []
    }
  },
  methods: {
    async requestFlows() {
      let data = { page: 0, size: 1000 }
      let res = await flowList(data)
      if (res.code == 0) {
        this.flows = res.data.list
      }
    },
    opened() {
      if (this.flows.length == 0) {
        this.requestFlows()
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$emit('selected', this.model.flow_id)
          this.visible = false
        }
      })
    }
  }
}
</script>

<style scoped>
li.el-select-dropdown__item {
  height: 54px !important;
  padding: 5px 12px;
  box-sizing: border-box;
}
.flow-item {
  font-size: 12px;
  line-height: 22px;
}
</style>